__turbopack_context__.v({
  "bannerImage": "AiInRecruitingBanner-module__gx6eAG__bannerImage",
  "bannerSection": "AiInRecruitingBanner-module__gx6eAG__bannerSection",
  "bannerSubtitle": "AiInRecruitingBanner-module__gx6eAG__bannerSubtitle",
  "bannerText": "AiInRecruitingBanner-module__gx6eAG__bannerText",
  "bannerTitle": "AiInRecruitingBanner-module__gx6eAG__bannerTitle",
  "bannerTitleBlue": "AiInRecruitingBanner-module__gx6eAG__bannerTitleBlue",
  "bannerTitleUnderline": "AiInRecruitingBanner-module__gx6eAG__bannerTitleUnderline",
});
